import { doFetch } from "./service";

const CompanyResource = {};

const serviceUrl = '/dict-service-rest-portal/webresources/company';

/*

Registering new account and creating new Company with this account as admin. After account registration, activation of account is automatic, no email validation is needed.
Contact should be object with following properties:

MANDATORY :
    firstname
    surname
    email
    passwordHash

OPTIONAL :
    phone
    promo
    newsletterSubscription
    accountId
    accountSource
    newsletterCountry;
    gdprApproval
*/

CompanyResource.companyRegistration = (companyRegistrationRequest) => {
    return doFetch(serviceUrl + '/createCompany',
        {
            method : 'POST',
        },
        companyRegistrationRequest
    ).then(
        () => {
            return Promise.resolve();
        },
        () => {
            return Promise.reject('Authentication failed');
        }
    );
};

CompanyResource.getCompany = (getCompanyRequest) => {
    return doFetch(serviceUrl + '/getCompany',
        {
            method : 'POST',
        },
        getCompanyRequest
    ).then(
        () => {
            return Promise.resolve();
        },
        () => {
            return Promise.reject('Authentication failed');
        }
    );
};


CompanyResource.sendQuestion = (sendQuestionRequest) => {
    return doFetch(serviceUrl + '/sendQuestion',
        {
            method : 'POST',
        },
        sendQuestionRequest
    ).then(
        () => {
            return Promise.resolve();
        },
        () => {
            return Promise.reject('Authentication failed');
        }
    );
};

export default CompanyResource;




// WEBPACK FOOTER //
// ./src/service/CompanyResource.js